import { AxiosError } from 'axios';
import { LcaXLValidationError } from 'types/lca-results/LcaXLValidationError';

export default function isAxiosErrorWithLcaXLValidationErrors(
  error: Error | null | undefined
): error is AxiosError<LcaXLValidationError[]> {
  return error instanceof AxiosError && Array.isArray(error.response?.data);
}
